import { lowerFirst } from 'lodash';
import http from './http';

const qp = new URLSearchParams(window.location.search);
const platform = qp.get('platform');
const isNextGen = platform === 'NextGen';
const params = {};

export default {
  getPresets({ player, wheelIdentifier }) {
    const path = `/players/${player}/${wheelIdentifier}/presets`;
    if (isNextGen) {
      params.platform = lowerFirst(platform);
    }

    return http.get(path, {
      params,
    }).then((response) => {
      const result = response.data;
      return result;
    });
  },
  setPreset({ player, presets, wheelIdentifier }) {
    const path = `/players/${player}/${wheelIdentifier}/presets`;
    if (isNextGen) {
      params.platform = lowerFirst(platform);
    }

    return http.put(path, { presets }, { params }).then((response) => {
      const result = response.data;
      return result;
    });
  },
  deletePreset({ player, preset }) {
    const path = `/players/${player}/presets`;
    if (isNextGen) {
      params.platform = lowerFirst(platform);
    }

    return http.delete(path, { data: { preset }, params }).then((response) => {
      const result = response.data;
      return result;
    });
  },
};
